import Box, { BoxProps } from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import React, { FunctionComponent } from "react";

const PREFIX = "TabMargins";

const classes = {
	root: `${PREFIX}root`,
};

const StyledBox = styled(Box)(({
	theme,
}) => ({
	[`&.${classes.root}`]: {
		paddingLeft: theme.spacing(4),
		paddingRight: theme.spacing(4),
		paddingTop: theme.spacing(3),
	},
}));

export interface TabMarginsProps extends BoxProps {

}

const TabMargins: FunctionComponent<TabMarginsProps> = (props) => {
	const { className, ...otherProps } = props;

	return <StyledBox className={`${classes.root} ${className || ""}`} {...otherProps} />;
};

export default TabMargins;